// api.js

import axiosInstance from "../axiosInstance";

export const partnerService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/partner", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, clientId, searchValue) => {
    try {
      let response = await axiosInstance.get(
        `/partner?&$limit=${
          limit || 15
        }&$skip=${skip || 0}&${clientId ? `client_id=${clientId}` : ""}&${
          searchValue ? `&username[$search]=${searchValue}` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  edit: async (id, obj) => {
    try {
      let response = await axiosInstance.patch(`/partner/${id}`, obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/partner/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
